import { FormControl, FormGroup } from '@angular/forms';

import { AIPromptCore } from '@empathy/survey/base';

import { IAIPromptForm } from './ai-prompt-form.interface';

export class AIPromptForm {
  form = new FormGroup<IAIPromptForm>({
    reference: new FormControl<string>(''),
    questionText: new FormControl<string>(''),
    answerText: new FormControl<string>(''),
    completed: new FormControl<boolean>(false)
  });

  constructor(prompt: AIPromptCore = null) {
    if (prompt) {
      this.form.patchValue(prompt);
    }
  }
}
